import { useTranslation } from 'next-i18next';
import { getAbTestLifecycleState } from '@bridebook/toolbox/src/ab-testing/lib/selectors';
import { useABTestV2Integration } from '@bridebook/web/lib/ab-tests/hooks/use-ab-test-v2-integration';
import { IApplicationState } from '@bridebook/web/lib/types';
import { useSelector } from '@bridebook/web/lib/utils';

const testId = 'LIVE-29079_EnquiryCtaGermanCopy';

export const useABTest_EnquiryCtaGermanCopy = () => {
  const { i18n } = useTranslation();

  useABTestV2Integration({
    testId,
    triggerCondition: ['de-DE', 'de-AT', 'de-CH'].includes(i18n.language),
  });
};

export const getVariant_EnquiryCtaGermanCopy = (state: IApplicationState) =>
  getAbTestLifecycleState(state, testId)?.variant;

export const useEnquiryCtaGermanCopyVariant = () => useSelector(getVariant_EnquiryCtaGermanCopy);
